import { FunctionComponent } from "react";
import Link from "rivals/components/shared/Link";
import { ForecastTypes } from "rivals/shared/interfaces/Futurecast/index";
import styles from "./ForecastActivity.module.scss";
import { OwnProps } from "./types";

const ForecastActivity: FunctionComponent<OwnProps> = ({
  forecast: {
    forecastCollegeName,
    forecastType,
    forecasterName,
    forecasterProfileUrl,
    previousCollegeName,
    prospectName,
    prospectPositionAbbreviation,
    prospectProfileImageUrl,
    prospectProfileUrl,
    prospectRecruitYear,
    prospectStars,
    stylizedForecastDate
  }
}) => {
  const prospectStats = `(${prospectRecruitYear}, ${prospectStars}-star ${prospectPositionAbbreviation}) `;
  let headerText, actionItem, forecastResult;

  if (forecastType == ForecastTypes.UNLIKELY) {
    headerText = "Unlikely Futurecast";
    actionItem = "'s forecast of ";
    forecastResult = ` to ${forecastCollegeName} is now unlikely.`;
  } else if (forecastType == ForecastTypes.UPDATED) {
    headerText = "Updated Futurecast";
    actionItem = " updates forecast for ";
    forecastResult = `from ${previousCollegeName} to ${forecastCollegeName}.`;
  } else {
    headerText = "New Futurecast";
    actionItem = " forecasts ";
    forecastResult = ` to ${forecastCollegeName}.`;
  }

  return (
    <div className={styles.forecastActivity}>
      <div className={styles.activityText}>
        <div className={styles.forecastType}>{headerText}</div>
        <div className={styles.forecastText}>
          <b>
            {forecasterProfileUrl ? (
              <Link href={forecasterProfileUrl}>{forecasterName}</Link>
            ) : (
              forecasterName
            )}
          </b>
          {actionItem}
          <b>
            <Link href={prospectProfileUrl}>{prospectName}</Link>
          </b>{" "}
          {prospectStats} {forecastResult}
        </div>
        <div className={styles.forecastTime}>{stylizedForecastDate}</div>
      </div>
      <Link className={styles.profileImage} href={prospectProfileUrl}>
        <img
          alt="profile image"
          className={styles.profileImage}
          src={
            prospectProfileImageUrl ||
            "/static/icons/icons_prospectprofile_avatar.svg"
          }
        ></img>
      </Link>
    </div>
  );
};

export default ForecastActivity;
